





















































import v8n from 'v8n';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import authModule from '@/store/Auth';
import snackModule from '@/store/Snack';

import AvatarUpload from '@/components/common/AvatarUpload.vue';
import CountrySelect from '@/components/common/CountrySelect.vue';
import LegislationSelect from '@/components/common/LegislationSelect.vue';
import {
  OrganisationType,
  OrganisationUser,
  Organisation,
  Legislation,
} from '@/api';
import { OrganisationUserRole } from '@/api/models/OrganisationUser';
import SubscriptionPortalBanner from '@/components/dashboard/SubscriptionPortalBanner.vue';
import CancelSubscriptionBanner from '@/components/dashboard/CancelSubscriptionBanner.vue';

@Component({
  components: {
    AvatarUpload,
    CancelSubscriptionBanner,
    CountrySelect,
    LegislationSelect,
    SubscriptionPortalBanner,
  },
})
export default class OrganisationDetails extends Vue {
  @Prop({ required: true }) readonly item: Organisation;

  @Prop({ type: Boolean, default: false }) readonly canEdit: boolean;

  organisation = new Organisation(); // tmp value

  valid = false;

  loading = false;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('common.validation.generalRequired'),
  ];

  owner: OrganisationUser | null = null;

  ownerLoading = true;

  legislation: Legislation | null = null;

  get isOwner() {
    return authModule.isOwner;
  }

  get showPortalBanner() {
    if (!this.isOwner) return false;
    return this.organisation.orgType !== OrganisationType.TrainingSession;
  }

  get isUser() {
    return authModule.isUser;
  }

  get showCancelBanner() {
    if (!this.isOwner) return false;
    return [
      OrganisationType.Regular,
      OrganisationType.TrainingProvider,
    ].includes(this.organisation.orgType);
  }


  get userScopeFactory() {
    return () => {
      if (!authModule.activeOrganisation) {
        throw new Error(
          this.$t('common.alerts.missingActiveOrganisation') as string,
        );
      }
      return OrganisationUser.includes(['user']).where({
        organisation: authModule.activeOrganisation.organisation.id,
      });
    };
  }

  async save() {
    if (!this.organisation.id) {
      throw new Error(this.$t('organisations.alerts.missing') as string);
    }
    try {
      this.loading = true;
      if (this.legislation && this.legislation.id) {
        this.organisation.defaultLegislation = this.legislation.coreId;
      }
      await this.organisation.save();
      window.location.reload();
      snackModule.setSuccess(this.$t('organisations.alerts.updated') as string);
    } catch (e) {
      snackModule.setError({
        text: this.$t('organisations.alerts.notUpdated') as string,
        errors: e.response.errors,
      });
    } finally {
      this.loading = false;
    }
  }

  @Watch('item', { immediate: true })
  async itemChanged() {
    this.organisation = this.item.dup();
    if (this.organisation.owner) {
      try {
        const owners = (
          await OrganisationUser.includes('user')
            .where({
              organisation: this.organisation.id,
              role: OrganisationUserRole.Owner,
            })
            .all()
        ).data;
        if (owners) {
          [this.owner] = owners;
        }
      } catch (e) {
        snackModule.setError({
          text: this.$t('organisations.alerts.ownerError') as string,
          errors: e.response.errors,
        });
      } finally {
        this.ownerLoading = false;
      }
    }
  }
}
